const getTagOptions = (values=[]) => {
    return values.map(({id, name}) => {
        return {value: id, label: name};
    });
};

export default getTagOptions;